<template>
  <div id="orderlist">
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul class="info-list">
          <li><span>供应商</span>：<span>{{ titleData[0].SUPPLIER_NAME }}</span></li>
          <li><span>送货日期</span>：<span>{{ titleData[0].SEND_DAY }}</span></li>
          <li><span>备注</span>：<span>{{ titleData[0].REMARKS }}</span></li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul class="info-list">
          <li><span>制单人</span>：<span>{{ managername }}</span></li>
          <li><span>订单编号</span>：<span>{{ titleData[0].ORDER_CODE }}</span></li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="font-weight: bold;">
      <el-col>
        入库单详情：
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" max-height="520"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="AFTER_PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="AFTER_NAME" label="产品名称" min-width="80"></el-table-column>
          <el-table-column prop="AFTER_TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="60"></el-table-column>
          <el-table-column prop="AFTER_COUNT" label="入库数量" min-width="70"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量" min-width="70"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退货原因" min-width="80"></el-table-column>
          <el-table-column prop="AFTER_PRICE" label="单价" min-width="50"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="70"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column>
          <el-table-column prop="WORTH" label="总价值" min-width="70"></el-table-column>
          <el-table-column prop="REAL_WORTH" label="实际入库价值" min-width="70"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注" min-width="80"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button style="margin-top: 20px" type="primary" @click="retuenWare">退货</el-button>
      </el-col>
    </el-row>
    <el-row style="font-weight: bold;margin-top: 20px">
      <el-col>
        订单详情：
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="orderData" stripe border style="width: 100%" max-height="520">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="验收数量"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="80"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column>
          <el-table-column prop="REAL_FEE" label="总价值"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-if="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in stepOr.DATA" :key="item.value"></el-step>
        </el-steps>
        <h4 v-else style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <el-drawer title="退货信息" :visible.sync="returnVisible" size="70%">
      <el-form :model="returnForm" v-if="RETURN_PURCHASE_DAY">
        <el-form-item label="退货日期：">
          <el-date-picker v-model="returnForm.SEND_DAY" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="returnList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="AFTER_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="AFTER_TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="AFTER_COUNT" label="入库数量" width="80"></el-table-column>
        <el-table-column prop="LOCATION_COUNT" label="库位数量" width="80" v-if="WAREHOUSE_MODE == 2"></el-table-column>
        <el-table-column label="退货数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" @change="countChange(scope.row)"
              :placeholder="`最多可退${scope.row.AFTER_COUNT - scope.row.RETURN_COUNT}`"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="库位" width="180" v-if="WAREHOUSE_MODE == 2">
          <template slot-scope="scope">
            <el-select v-model="scope.row.LOCATION_CODE" clearable filterable @change="changCount(scope.row)">
              <el-option v-for="item in scope.row.positionList" :key="item.CODE" :value="item.CODE" :label="item.CODE">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="drawer-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitReturn">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { historyInDetailFun, historyReturnFun, getShopReturnLocationFun } from 'api/warehouseManager';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

export default {
  data () {
    return {
      statusFlag: 0,
      stepOr: [],
      managername: sessionStorage.getItem('name'),
      DELIVER_CODE: sessionStorage.getItem('ORDER_CODE'),
      tableData: [],
      orderData: [],
      titleData: [{
        SUPPLIER_NAME: '',
        PROJECT_ADDRESS: '',
        ORDER_CODE: '',
        PROJECT_NAME: '',
        SEND_DAY: '',
        PROJECT_TELPHONE: '',
        DK_NAME: '',
      }],
      currentRow: {},
      currentCount: 0,
      snapReturnList: [],
      FormVisible: false,
      backItem: {},
      Form: {},
      PRODUCT_COUNT: '',
      DETAIL_ID: '',
      returnVisible: false,
      returnForm: {},
      formLabelWidth: '120px',
      returnList: [],
      checkedArray: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      RETURN_PURCHASE_DAY: false,
    };
  },
  created () {
    this.getRecordDetail();
  },
  methods: {
    // ----------------------退货
    returnWarehouse (row) {
      this.returnVisible = true;
      this.returnForm = row;
    },
    returnClose () {
      this.returnVisible = false;
    },
    submitReturn () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.returnList.map((item) => ({
            BATCH: item.BATCH,
            PRODUCT_CODE: item.AFTER_PRODUCT_CODE,
            PRODUCT_COUNT: item.COUNT,
            RETURN_REASON: item.COMMENT ? item.COMMENT : '',
            LOCATION_CODE: item.LOCATION_CODE || 0,
            PRODUCTION_DATE: item.PRODUCTION_DATE,
            AFTER_TYPE_UNIT: item.AFTER_TYPE_UNIT,
            DETAIL_ID: item.ORDER_DETAIL_ID,
          }));
          const flag = submitArr.every(({ AFTER_TYPE_UNIT, PRODUCT_COUNT }) => {
            if (util.JudgmentUnit(AFTER_TYPE_UNIT)) {
              if (validation.数量两位小数正数验证(PRODUCT_COUNT)) {
                return true;
              }
            } else {
              if (validation.数量整数正数验证(PRODUCT_COUNT)) {
                return true;
              }
            }
          });
          const lacationFlag = submitArr.find((item) => {
            if (!item.LOCATION_CODE) {
              return true;
            }
          });
          if (!flag) {
            this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (this.WAREHOUSE_MODE == 2 && lacationFlag) {
            this.$message.show({ text: '请选择库位', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
            DETAILS: submitArr,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            RECORD_ID: Number(sessionStorage.getItem('RECORD_ID')),
            WAREHOUSE_MODE: this.WAREHOUSE_MODE,
          };
          if (this.returnForm.SEND_DAY) {
            params.SEND_DAY = this.returnForm.SEND_DAY;
          }
          historyReturnFun(params).then((result) => {
            this.$message.show({ text: '退货成功', type: 'success' });
            this.getRecordDetail();
            this.returnVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // ----------------------拉取数据
    getRecordDetail () {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
      };
      historyInDetailFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].IW_DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }));
          this.orderData = result[0].ORDER_DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }));
          this.titleData = result[0].ORDER_TITLE;
          this.stepOr = result[0].OR[0];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          this.RETURN_PURCHASE_DAY = Boolean(this.titleData[0].RETURN_PURCHASE_DAY);
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 选择需要退货的商品
    handleSelectionChange (val) {
      this.checkedArray = val;
    },
    retuenWare () {
      if (this.checkedArray.length !== 0) {
        this.returnList = [...this.checkedArray];
        this.returnVisible = true;
        if (this.WAREHOUSE_MODE == 2) {
          const arr = [];
          this.checkedArray.map((item) => {
            arr.push(item.AFTER_PRODUCT_CODE);
          });
          const params = {
            PRODUCT_CODE: arr,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            OMS_ID: Number(sessionStorage.getItem('tcId')),
            ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
          };
          getShopReturnLocationFun(params).then((result) => {
            const arrs = this.returnList.map((item) => {
              const data = result.find((i) => item.AFTER_PRODUCT_CODE == i.AFTER_PRODUCT_CODE && item.BATCH == i.BATCH);
              return {
                ...item,
                positionList: data ? data.LOCATION : [],
              };
            });
            this.returnList = arrs;
            this.returnVisible = true;
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
    },
    changCount (row) {
      const data = row.positionList.filter((item) => item.CODE == row.LOCATION_CODE);
      if (data.length !== 0) {
        row.LOCATION_COUNT = data[0].PRODUCT_COUNT;
      } else {
        row.LOCATION_COUNT = '';
      }
      if (Number(row.COUNT) > Number(row.LOCATION_COUNT)) {
        this.$message.show({ text: '退货数量不能大于库位数量', type: 'warning' });
      }
    },
    countChange (row) {
      if (!validation.数量两位小数正数验证(row.COUNT)) {
        this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
        return false;
      }
      if (!this.$util.JudgmentUnit(row.AFTER_TYPE_UNIT) && !validation.数量整数正数验证(row.COUNT)) {
        this.$message.show({ text: '请输入正整数的退货数量', type: 'warning' });
        return false;
      }
      if (Number(row.COUNT) > Number(row.AFTER_COUNT - row.RETURN_COUNT)) {
        this.$message.show({ text: '总退货数量不能大于入库数量', type: 'warning' });
        return false;
      }
      if (this.WAREHOUSE_MODE == 2) {
        this.changCount(row);
      }
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

.drawer-footer {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/historyInDetail.vue